import { FormControl } from 'baseui/form-control'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import useAddressSelector from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/AddressSelector/useAddressSelector'
import PropTypes from 'prop-types'

const AddressSelectorField = ({ module, validations, saleName }) => {
  const { t, label, addressesList, addressSelectorHandler, selectedValue, addressError, isEditable } =
    useAddressSelector(module, validations, saleName)

  if (!addressesList?.length) {
    return module === 'client' ? null : <p>{t('common:no_addresses_available')}</p>
  }

  return (
    <FormControl error={addressError}>
      <SDSelect
        label={label}
        disabled={!isEditable}
        optionsList={addressesList}
        onChangeHandler={params => addressSelectorHandler(params.option?.id)}
        selectedValue={selectedValue}
        placeholder={t('common:choose')}
      />
    </FormControl>
  )
}

AddressSelectorField.propTypes = {
  module: PropTypes.string,
  validations: PropTypes.object,
  saleName: PropTypes.string,
}

export default AddressSelectorField
